function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
import * as tracking from "./tracking";
import { dispatchCustomEvent, useCustomEvent } from "../useCustomEvent";
var LOCALE_COOKIES = {
  countryCode: 'country_code',
  currency: 'currency',
  deliveryZone: 'delivery_zone',
  countryName: 'country_name'
};
var DEFAULT_LOCALE = {
  currency: 'GBP',
  countryCode: 'GB',
  deliveryZone: 'MAINLAND_UK',
  countryName: 'United Kingdom'
};
var SET_LOCALE_EVENT = 'SET_LOCALE_EVENT';
export var useLocale = function useLocale(_ref) {
  var cookies = _ref.cookies;
  var _useState = useState(DEFAULT_LOCALE),
    _useState2 = _slicedToArray(_useState, 2),
    locale = _useState2[0],
    setLocale = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    localeUpdated = _useState4[0],
    setLocaleUpdated = _useState4[1];
  useEffect(function () {
    if (cookies) {
      var countryCode = cookies.get(LOCALE_COOKIES.countryCode) || DEFAULT_LOCALE.countryCode;
      var currency = cookies.get(LOCALE_COOKIES.currency) || DEFAULT_LOCALE.currency;
      var deliveryZone = cookies.get(LOCALE_COOKIES.deliveryZone) || DEFAULT_LOCALE.deliveryZone;
      var countryName = cookies.get(LOCALE_COOKIES.countryName) || DEFAULT_LOCALE.countryName;
      setLocale({
        currency,
        countryCode,
        deliveryZone,
        countryName
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
    handle updates using custom event to enable components rendered in different contexts to communicate.
    This is only need for the mononoth integration.
  */
  useCustomEvent(SET_LOCALE_EVENT, function (evt) {
    return setLocale(evt.detail);
  });
  useEffect(function () {
    if (localeUpdated && cookies) {
      cookies.set(LOCALE_COOKIES.currency, locale.currency);
      cookies.set(LOCALE_COOKIES.countryCode, locale.countryCode);
      cookies.set(LOCALE_COOKIES.deliveryZone, locale.deliveryZone);
      cookies.set(LOCALE_COOKIES.countryName, locale.countryName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);
  return [locale, function (updatedLocale, placement) {
    setLocaleUpdated(true);
    tracking.sendChangeLocaleEvent(locale, updatedLocale, placement);
    dispatchCustomEvent(SET_LOCALE_EVENT, updatedLocale);
  }];
};